var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 920,
    height: 1300,
    viewBox: "0 0 920 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M817 1C1267.63 1 1633 366.371 1633 817C1633 1267.63 1267.63 1633 817 1633C366.371 1633 1 1267.63 1 817C1 366.371 366.371 1 817 1Z",
    stroke: "#FFEF00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.608 1239.58C1303.35 1239.58 1568.46 975.869 1568.46 652.799C1568.46 329.729 1303.35 65.5426 978.608 65.5426C653.871 65.5426 388.253 329.248 388.253 652.823C388.253 976.398 653.34 1239.6 978.608 1239.6V1239.58Z",
    stroke: "#00A8E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M657.166 1568.46C982.896 1568.46 1248.82 1304.75 1248.82 981.682C1248.82 658.612 982.92 394.401 657.166 394.401C331.412 394.401 65.5394 658.131 65.5394 981.682C65.5394 1305.23 330.927 1568.46 657.19 1568.46H657.166Z",
    stroke: "#FF5C00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLines);
export default __webpack_public_path__ + "static/media/big-lines.5b1fa870832306c4e8d5d3d715091856.svg";
export { ForwardRef as ReactComponent };